import { useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { logout } from "../redux/slices/authSlice";
import { refreshRequests } from "../redux/slices/cachedRequestsSlice";
import { setLoaderState } from "../redux/slices/loaderSlice";
import { console_log } from "../utils/console_log";
import { paramsValidate } from "../utils/helpers";
import useApiEffect from "../utils/useApiEffect";
import { GetService } from "./services/requests-service";

const useGetData = ({
  route,
  params,
  onSuccess,
  notLoadData,
  disableUrlParam,
  responseType,
  headers,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [count, setCount] = useState(0);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingMoreData, setLoadingMoreData] = useState(true);
  const [errors, setErrors] = useState(null);
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search); // Query Params included in url
  const paramsObject = Object.fromEntries(urlParams.entries());
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
    pageNo: 1,
  });

  // ====handle Logout====
  const handleLogout = (error) => {
    dispatch(logout());
    dispatch(refreshRequests(true));
    navigate("/sign-in");
    setErrors(error?.response?.data?.error);
  };

  const getApi = async ({ params, disableUrlParam }) => {
    try {
      setLoading(true);
      dispatch(setLoaderState(true));
      const validatedParams = paramsValidate(
        disableUrlParam ? params : { ...paramsObject, ...params }
      );
      const res = await GetService({
        route,
        params: validatedParams,
        responseType,
        headers,
      });
      setData(res.data?.data || res.data);
      if (res?.data?.count) {
        const pageNoCalculate = Math.ceil(res?.data?.count / pagination?.limit);
        setCount(res.data.unseen);
        setLoadingMoreData(true);
        setPagination((prev) => ({
          ...prev,
          pageNo: pageNoCalculate,
          page: 2,
        }));
      }
      setLoading(false);
      dispatch(setLoaderState(false));
      const updateData = ({ newData }) => {
        setData(newData.result);
      };
      if (onSuccess) {
        // called To set Data when Edit Item on specific separate Route called with param for ex. Route of edit form by _id
        onSuccess(res, updateData); // Why ? Because when data of item is to much and have many calculatons so made it in a separate route individually
      }
      return res;
    } catch (error) {
      console_log("error ===>", { error });
      setErrors(error);
      setLoading(false);
      dispatch(setLoaderState(false));
      const status = error?.response?.status;
      if (status === 401 || status === 403) {
        handleLogout(error);
      } else {
        setErrors(error?.response?.data?.msg);
        // SweetAlert({ text: error?.response?.data?.error, status: error?.response?.data?.success })
      }
      return {
        error: error?.response?.data?.error || error?.response?.data?.msg,
      };
    }
  };
  useApiEffect(() => {
    if (!notLoadData) getApi({ params, disableUrlParam });
  }, [urlParams.toString()]);
  // For load more mode
  //=================================
  //loading more Logic //
  //=================================
  const onScrollLoadMore = (event) => {
    const { scrollTop, scrollHeight, clientHeight } = event.target;
    if (scrollTop + clientHeight >= scrollHeight && !loading) {
      loadMoreData();
    }
  };

  const loadMoreData = async () => {
    if (
      pagination?.pageNo >= 1 &&
      pagination?.page <= pagination?.pageNo &&
      loadingMoreData
    ) {
      setLoading(true);
      dispatch(setLoaderState(true));
      try {
        const filterParams = !params
          ? pagination
          : { page: pagination?.page + 1, limit: pagination?.limit, ...params };
        const apiParams = paramsValidate(filterParams);
        const res = await GetService({
          route,
          params: apiParams,
          responseType,
        });
        setPagination((prev) => ({ ...prev, page: prev?.page + 1 }));
        setData((prev) => {
          const newResults = res?.data?.result || [];
          return [...prev, ...newResults];
        });
        setLoading(false);
        dispatch(setLoaderState(false));
      } catch (error) {
        console_log({ error });
      }
    } else {
      setLoadingMoreData(false);
    }
  };

  return {
    loading: loading,
    data: data,
    count: count,
    setCount: setCount,
    errors: errors,
    setData: setData,
    getData: getApi,
    loadMoreData,
    loadingMoreData,
    setLoadingMoreData,
    onScrollLoadMore,
  };
};
export default useGetData;
